var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"informationIndex"},[_c('div',_vm._l((_vm.channelList),function(item,index){return _c('div',{key:index,staticClass:"channel-item",on:{"click":function($event){return _vm.skipDetails(item)}}},[_c('img',{attrs:{"src":item.image,"alt":""}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cc1cef8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/information/Index.vue
// module id = null
// module chunks = 